
export const handleModal = (state) => ({
  type: 'TOGGLE_MODAL',
  ...state
});

export const handleModalBanner = (state) => ({
  type: 'TOGGLE_MODAL_BANNER',
  ...state
});